import styled from 'styled-components';

import { mediaTiny } from '@xing-com/layout-tokens';
import { spaceXL, space4XL, spaceXXL, spaceL } from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

export const ContentSpacer = styled.div`
  margin-top: ${spaceXL};
  margin-bottom: ${space4XL};
`;

export const StyledHeadline = styled(Headline)`
  margin-bottom: ${spaceXXL};

  @media ${mediaTiny} {
    margin-bottom: ${spaceL};
  }
`;
